"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebVersion = exports.WebArea = exports.UserStatus = exports.UserType = exports.LoginMethod = void 0;
var LoginMethod;
(function (LoginMethod) {
    LoginMethod["PASSWORD"] = "password";
    LoginMethod["FACEID"] = "faceId";
    LoginMethod["FINGERPRINT"] = "fingerprint";
})(LoginMethod || (exports.LoginMethod = LoginMethod = {}));
var UserType;
(function (UserType) {
    UserType["CLIENT"] = "client";
    UserType["PROSPECT"] = "prospect";
})(UserType || (exports.UserType = UserType = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["LOGGEDIN"] = "loggedin";
    UserStatus["LOGGEDOUT"] = "loggedout";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var WebArea;
(function (WebArea) {
    WebArea["PUBLIC"] = "public";
    WebArea["PRIVATE"] = "private";
    WebArea["ONBOARDING"] = "onboarding";
})(WebArea || (exports.WebArea = WebArea = {}));
var WebVersion;
(function (WebVersion) {
    WebVersion["DESKTOP"] = "desktop";
    WebVersion["MOBILE"] = "mobile";
    WebVersion["TABLET"] = "tablet";
})(WebVersion || (exports.WebVersion = WebVersion = {}));
//# sourceMappingURL=types.js.map